(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  function initCollectionBanner(root) {
    const description = root.querySelector('[data-collapsible-description]');
    const toggle = root.querySelector('[data-description-toggle]');
    if (!description || !toggle) return;

    const showMore = root.dataset.showMore || 'Read more';
    const showLess = root.dataset.showLess || 'Read less';

    const syncOverflow = () => {
      description.classList.add('is-collapsed');
      description.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = showMore;

      requestAnimationFrame(() => {
        const needsToggle = description.scrollHeight > description.clientHeight + 2;
        toggle.hidden = !needsToggle;
        if (!needsToggle) {
          description.classList.remove('is-collapsed');
        }
      });
    };

    toggle.addEventListener('click', () => {
      const expanded = description.classList.toggle('is-expanded');
      if (expanded) {
        description.classList.remove('is-collapsed');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = showLess;
      } else {
        description.classList.add('is-collapsed');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = showMore;
        requestAnimationFrame(syncOverflow);
      }
    });

    syncOverflow();

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => {
        if (!description.classList.contains('is-expanded')) {
          syncOverflow();
        }
      });
      ro.observe(description);
    }
  }

  function initAllCollectionBanners(container) {
    container.querySelectorAll('[data-collection-banner-root]').forEach(initCollectionBanner);
  }

  document.addEventListener('DOMContentLoaded', () => initAllCollectionBanners(document));
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) {
      initAllCollectionBanners(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
